import { useTranslation } from 'react-i18next';

import { OpText } from 'new-components/DLS/OpText/OpText';
import { OpButton } from 'new-components/DLS/OpButton/OpButton';
import { OpFlex } from 'new-components/DLS/OpFlex/OpFlex';
import { useLogout } from 'utils/customHooks/useLogout';
import { OpPage } from 'new-components/OpPage/OpPage';
import { ProductBranding } from 'new-components/ProductBranding/ProductBranding';

import './TrialEnd.scss';

const TrialEnd = () => {
  const { t } = useTranslation();
  const { logout } = useLogout();

  return (
    <OpPage className="trial-end-page">
      <OpFlex
        className="trial-end-page__content"
        justify="center"
        align="center"
        vertical
        gap={16}
      >
        <ProductBranding label="Visitor" testId="visitor-logo" />
        <OpText size="extraLarge" fontWeight="700">
          {t('Your trial has ended')}
        </OpText>
        <OpText className="trial-end-page__description">
          {t('You no longer have access to Visitor.')}
        </OpText>
        <OpButton
          className="trial-end-page__button"
          type="primary"
          onClick={logout}
        >
          {t('Logout')}
        </OpButton>
      </OpFlex>
    </OpPage>
  );
};

export default TrialEnd;
